export enum AmmendIssueLoadingState {
    loadingIssue = 'Problem loading Issue',
    savingChanges = 'Saving Changes',
    submittingCompletion = 'Submitting Issue...',
    submittingReOpening = 'Re-Opening Issue...'
}